import React from 'react'
import PropTypes from 'prop-types'

import DateInput from '../form_sections/DateInput'
import StandardButton from '../app_components/StandardButton'
import LocationSettings from '../setting_components/LocationSettings'
import DashboardSectionShell from './DashboardSectionShell'
import DashboardLanguageField from './DashboardLanguageField'
import { PROFILE_COMPLETION_ITEMS } from './profileCompletionHelpers'
import { getMaxBirthdayDate, isAtLeastMinAge } from '../../utils/birthdayHelpers'

class DashboardProfileCompletionSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      birthday: null,
      loaded: false,
      savingBirthday: false,
    }

    this.updateBirthday = this.updateBirthday.bind(this)
    this.saveBirthday = this.saveBirthday.bind(this)
  }

  componentDidMount() {
    $.ajax({ url: '/get_current_user', dataType: 'json', type: 'GET' }).then((userRes) => {
      const user = JSON.parse(userRes.data.current_user)
      this.setState({
        birthday: user.birthday ? new Date(user.birthday) : null,
        loaded: true,
      })
    })
  }

  formatBirthday(date) {
    if (!date) return ''
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
  }

  updateBirthday(value) {
    this.setState({ birthday: value })
  }

  saveBirthday() {
    if (!this.state.birthday || !isAtLeastMinAge(this.state.birthday)) return

    this.setState({ savingBirthday: true })
    $.ajax({
      url: '../update_user',
      dataType: 'JSON',
      type: 'POST',
      data: {
        user: {
          birthday: this.formatBirthday(this.state.birthday),
        },
      },
      success: () => {
        this.setState({ savingBirthday: false })
        if (this.props.onUpdated) this.props.onUpdated()
      },
      error: () => {
        this.setState({ savingBirthday: false })
      },
    })
  }

  itemMeta(key) {
    return PROFILE_COMPLETION_ITEMS.find((item) => item.key === key) || {}
  }

  renderField(key) {
    const meta = this.itemMeta(key)

    if (key === 'birthday') {
      return (
        <div key={key} className="dashboardProfileField">
          <div className="dashboardProfileField__copy">
            <p className="dashboardProfileField__label">{meta.label}</p>
            <p className="dashboardProfileField__description">{meta.description}</p>
          </div>
          <DateInput
            onChange={this.updateBirthday}
            label="Year of birth"
            value={this.state.birthday}
            maxDate={getMaxBirthdayDate()}
            showYearDropdown
            showMonthDropdown
            tone="green"
            hint="You must be at least 18 years old"
          />
          <div className="dashboardProfileField__actions">
            <StandardButton
              text="Save birthday"
              size="small"
              primary
              loading={this.state.savingBirthday}
              onClick={this.saveBirthday}
            />
          </div>
        </div>
      )
    }

    if (key === 'location') {
      return (
        <div key={key} className="dashboardProfileField">
          <div className="dashboardProfileField__copy">
            <p className="dashboardProfileField__label">{meta.label}</p>
            <p className="dashboardProfileField__description">{meta.description}</p>
          </div>
          <LocationSettings
            dashboard
            onUpdated={this.props.onUpdated}
          />
        </div>
      )
    }

    if (key === 'native_language') {
      return (
        <DashboardLanguageField
          key={key}
          label={meta.label}
          description={meta.description}
          nativeOnly
          onUpdated={this.props.onUpdated}
        />
      )
    }

    if (key === 'learning_language') {
      return (
        <DashboardLanguageField
          key={key}
          label={meta.label}
          description={meta.description}
          onUpdated={this.props.onUpdated}
        />
      )
    }

    return null
  }

  render() {
    const { profileCompletion } = this.props
    const missingKeys = PROFILE_COMPLETION_ITEMS
      .map((item) => item.key)
      .filter((key) => profileCompletion[key])

    if (!profileCompletion.incomplete || missingKeys.length === 0) {
      return null
    }

    if (!this.state.loaded) {
      return (
        <DashboardSectionShell
          icon="user"
          title="Complete your profile"
          subtitle="We need a few details to find your language matches."
        >
          <p className="dashboardHomeSection__loading">Loading…</p>
        </DashboardSectionShell>
      )
    }

    return (
      <DashboardSectionShell
        icon="user"
        title="Complete your profile"
        subtitle="We need a few details to find your language matches."
      >
        <div className="dashboardProfileCompletion">
          {missingKeys.map((key) => this.renderField(key))}
        </div>
      </DashboardSectionShell>
    )
  }
}

DashboardProfileCompletionSection.propTypes = {
  profileCompletion: PropTypes.object.isRequired,
  onUpdated: PropTypes.func,
}

export default DashboardProfileCompletionSection
